import find from 'lodash/find';
import { fitBounds } from 'google-map-react';

const MAPS_STATE_IDENTIFIER_PROPERTY = ['administrative_area_level_1', 'political'];

class LocationService {
  static initGoogleMaps ({ maps }) {
    this.maps = maps;
    this.geocoder = new maps.Geocoder();
  }

  static geolocateUser () {
    return new Promise((res, rej) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          res(position);
        }, (error) => {
          // this.history.push(ROUTE_MANUAL_LOCATION);
          rej(error);
        }, {
          timeout: 8500,
          enableHighAccuracy: false,
        });
      } else {
        // this.history.push(ROUTE_MANUAL_LOCATION);
        rej(new Error('Browser does not support geolocation'));
      }
    });
  }

  static geocode (address) {
    return new Promise((res, rej) => {
      this.geocoder.geocode({ address }, (results, status) => {
        /* eslint-disable eqeqeq */
        if (status == this.maps.GeocoderStatus.OK) {
        /* eslint-enable eqeqeq */
          const result = results[0];
          const loc = result.geometry.location;
          const region = find(result.address_components, (component) => (
            MAPS_STATE_IDENTIFIER_PROPERTY.every((prop) => component.types.includes(prop))
          ));

          res({
            region,
            latitude: loc.lat(),
            longitude: loc.lng(),
          });
        } else {
          const errorMessage = `Geocode was not successful for the following reason: ${status}`;
          rej(errorMessage);
        }
      });
    });
  }

  static fitBounds (arrayOfLatLngs, mapDimensions) {
    const googleMapBounds = new this.maps.LatLngBounds();

    arrayOfLatLngs.forEach((latLng) => {
      googleMapBounds.extend(latLng);
    });

    let ne = googleMapBounds.getNorthEast();
    let sw = googleMapBounds.getSouthWest();

    ne = { lat: ne.lat(), lng: ne.lng() };
    sw = { lat: sw.lat(), lng: sw.lng() };

    const bounds = { ne, sw };

    // there's this weird bug that happens that if the ne.lat and sw.lat are
    // equal the bounds get distorted. Example, if postal code 63117 bounds to
    // somewhere in China.
    if (bounds.ne.lat === bounds.sw.lat) {
      bounds.sw.lat -= 0.0000001;
    }
    if (bounds.ne.lng === bounds.sw.lng) {
      bounds.sw.lng -= 0.0000001;
    }

    return fitBounds(bounds, mapDimensions);
  }
}

export default LocationService;
